export const handleEnterKey = async (
  e: React.KeyboardEvent<HTMLInputElement>,
  callback?: () => Promise<void> | void
) => {
  const isPressEnter = e.key === 'Enter' || e.code === 'Enter';
  if (!isPressEnter) return;

  await callback?.();
};
